import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Loadable from 'react-loading-overlay'

@observer(['activities', 'agreements', 'companies', 'globals', 'invoices', 'quotes', 'quickbooks'])

export default class Invoice extends Component {
    constructor(props) {
        super(props)

        this.state = {
        loadableState: true
        }

        let invoiceId = this.props.params.invoiceId

        this.loadInvoiceDetails(invoiceId)
    }

    loadInvoiceDetails(invoiceId) {
        this.props.invoices.loadInvoice(invoiceId, (data) => {
            let row = {
                id: data.companyId
            }
            this.props.companies.loadCompanyDetails(row)

            this.props.invoices.loadInvoiceHardware(invoiceId, data.qbItemList)

            if (data.agreementId > 0) {
                this.props.agreements.loadAgreement(data.agreementId)
            }

            //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
            this.props.activities.logNewActivity(localStorage.getItem('userId'), 'read', 1, invoiceId, 1, data.companyId)

            this.setState({
                loadableState: false
            })
        })
    }

    formatTaxExempt(cell, row) {
        return (cell == 1 ? 'Yes' : 'No')
    }

  render() {

    let hardwareList = ''
    let subtotal = 0
    let taxTotal = this.props.invoices.invoice.taxTotal
    let shippingCost = this.props.invoices.invoice.shippingCost

    if (this.props.invoices.invoiceHardware.length > 0) {
      console.log('Hardware: ', this.props.invoices.invoiceHardware)
      hardwareList = this.props.invoices.invoiceHardware.map((hw) => {
        subtotal += parseFloat(hw.cost) * parseFloat(hw.quantity)
        return (<tr>
          <td>{ hw.quantity }</td>
          <td>{ hw.hardwareName }</td>
          <td>{ hw.hardwareDescription }</td>
          <td>${ hw.cost.toFixed(2) }</td>
          <td>${ (hw.quantity * hw.cost).toFixed(2) }</td>
        </tr>)
      })
    }

    let notesTable = ''

    if (this.props.invoices.invoice.note) {
      notesTable = 
        <table style={{ width: '90%', margin: '5%' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={ 3 }><b>Notes</b></td>
            </tr>
            <tr>
              <td colSpan={ 3 } style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{ this.props.invoices.invoice.note }</td>
            </tr>
          </tbody>
        </table>
    }

    let serialNumbersTable = ''

    if (this.props.invoices.invoice.serialNumbers) {
      serialNumbersTable =
        <table style={{ width: '90%', margin: '5%' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={ 3 }><b>Serial Numbers</b></td>
            </tr>
            <tr>
              <td colSpan={ 3 } style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{ this.props.invoices.invoice.serialNumbers }</td>
            </tr>
          </tbody>
        </table>
    }

    let termsTable = ''

    if (this.props.invoices.invoice.agreementId > 0) {
      termsTable = 
        <div>
          <table style={{ width: '90%', margin: '5%' }}>
            <tbody>
              <tr>
                <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={ 3 }><b>TERMS AND CONDITIONS</b></td>
              </tr>
              <tr>
                <td colSpan={ 3 } style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{ this.props.agreements.agreementDetail.agreement }</td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Print Name:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Signature:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Title:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Date:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
            </tbody>
          </table>
        </div>
    }

    let today = new Date()

    return (
      <div className="right_col" role="main">
        <div className="">
          <div className="page-title hidden-print">
            <div className="title_left"></div>
          </div>
          <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
            <div style={{ height: 'inherit' }} >
              <table style={{ width: '90%', margin: '5%'}}>
                <tbody>
                  <tr>
                    <td colSpan={ 4 } style={{ textAlign: 'center' }}>
                      <img src="/images/logo-white.png" /><br />
                      <small>30724 Benton Road Suite C 302-413<br />Winchester, CA 92596</small>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 } style={{ paddingTop: '30px', fontSize: '150%', textAlign: 'center' }}><b>Invoice # {this.props.invoices.invoice.id}</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}>Date: { this.props.invoices.invoice.formattedQuoteDate }</td>
                    <td style={{ paddingTop: '30px' }}>Rep: { this.props.invoices.invoice.userFullName }</td>
                    <td style={{ paddingTop: '30px' }}>Contract Term: { this.props.invoices.invoice.contractTermName }</td>
                    <td style={{ paddingTop: '30px' }}>Payment Term: { this.props.invoices.invoice.paymentTermName }</td>
                  </tr>
                  <tr>
                    <td colSpan={ 2 } style={{ paddingTop: '30px' }}><b>Bill To</b></td>
                    <td colSpan={ 2 } style={{ paddingTop: '30px' }}><b>Ship To</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{ this.props.companies.details.name }</small></td>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{ this.props.companies.details.name }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Name</b></small></td>
                    <td><small>{ this.props.invoices.invoice.billingAddressName }</small></td>
                    <td><small><b>Name</b></small></td>
                    <td><small>{ this.props.invoices.invoice.shippingAddressName }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Address</b></small></td>
                    <td><small>{ this.props.invoices.invoice.billingAddressAddress }</small></td>
                    <td><small><b>Address</b></small></td>
                    <td><small>{ this.props.invoices.invoice.shippingAddressAddress }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>City</b></small></td>
                    <td><small>{ this.props.invoices.invoice.billingAddressCity }</small></td>
                    <td><small><b>City</b></small></td>
                    <td><small>{ this.props.invoices.invoice.shippingAddressCity }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>State</b></small></td>
                    <td><small>{ this.props.invoices.invoice.billingAddressState }</small></td>
                    <td><small><b>State</b></small></td>
                    <td><small>{ this.props.invoices.invoice.shippingAddressState }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{ this.props.invoices.invoice.billingAddressZipCode }</small></td>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{ this.props.invoices.invoice.shippingAddressZipCode }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Country</b></small></td>
                    <td><small>{ this.props.invoices.invoice.billingAddressCountry }</small></td>
                    <td><small><b>Country</b></small></td>
                    <td><small>{ this.props.invoices.invoice.shippingAddressCountry }</small></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 } style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }}><b>Items</b></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 }>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <td><b>QTY</b></td>
                            <td><b>Item</b></td>
                            <td><b>Description</b></td>
                            <td><b>Price</b></td>
                            <td><b>Total</b></td>
                          </tr>
                          { hardwareList }
                          <tr>
                            <td style={{ paddingTop: '30px' }} colSpan={ 3 }></td>
                            <td style={{ paddingTop: '30px', textAlign: 'right' }}><b>SUBTOTAL:</b>&nbsp;&nbsp;</td>
                            <td style={{ paddingTop: '30px' }}>${ subtotal.toFixed(2) }</td>
                          </tr>
                          <tr>
                            <td colSpan={ 3 }></td>
                            <td style={{ textAlign: 'right' }}><b>TAX:</b>&nbsp;&nbsp;</td>
                            <td>${ taxTotal }</td>
                          </tr>
                          <tr>
                            <td colSpan={ 3 }></td>
                            <td style={{ textAlign: 'right' }}><b>SHIPPING:</b>&nbsp;&nbsp;</td>
                            <td>${ shippingCost }</td>
                          </tr>
                          <tr>
                            <td colSpan={ 3 }></td>
                            <td style={{ textAlign: 'right' }}><b>TOTAL:</b>&nbsp;&nbsp;</td>
                            <td>${ (parseFloat(subtotal) + parseFloat(taxTotal) + parseFloat(shippingCost)).toFixed(2) }</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              {notesTable}
            </div>
            <div className="pagebreak-print">
              {serialNumbersTable}
            </div>
            <div className="clearfix"></div>
              {termsTable}
            </Loadable>
            <div className="clearfix"></div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice.js